import {Injectable, EventEmitter} from '@angular/core';

@Injectable()
export class FmcLibraryNotificationService {

  public notificationAlert: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  // for notification alerts
  notify(type: string, message: string, title?: string, options?: any) {
    this.notificationAlert.next({type, message, title, options});
  }
}
